import React, { memo } from 'react'
import { DraggingElem } from './DraggingElem'

export const SnappedPreview = memo(({
  scale,
  currentDragAssets,
  visible,
  previewWidth,
  previewHeight,
  transformX,
  transformY,
  isMultipleDrag,
  offset,
  dragItem,
  transitions,
  isExternalSource,
}) => {
  if (!visible) return null
  return (
    <div style={{
      width: previewWidth,
      height: previewHeight,
      position: 'relative',
      transform: `translate(${transformX}px, ${transformY}px)`,
    }}
    >
      <DraggingElem
        isMultipleDrag={isMultipleDrag}
        offset={offset}
        dragItem={dragItem}
        currentDragAssets={currentDragAssets}
        scale={scale}
        transitions={transitions}
        isExternalSource={isExternalSource}
      />
    </div>
  )
})
